import React, {useEffect, useState} from "react";
import {getMachineData} from "../API";
import {useVending} from "./VendingProvider";
import {Image, Spinner} from "@nextui-org/react";

export const Menu = () => {
    const [machine, setMachine] = useState({});
    const {idMachine} = useVending();

    useEffect(() => {
        GetData();
    }, []);

    async function GetData() {
        const data = await getMachineData(idMachine);
        if (data) {
            document.documentElement.style.backgroundColor = data.background;
            setMachine(data);
        }
    }

    return (
        <>
            <div className="top-3 flex flex-col items-center">
                <img
                    src={`https://expendedora.online/img/machine/${machine?.image}`}
                    width={200}
                    height={200}
                    className="mx-auto rounded-full"
                    alt="Imagen de la expendedora"/>
                <h1 className="text-center mx-auto font-bold text-3xl pt-5">{machine?.name}</h1>
                <h2 className="text-center mx-auto text-2xl">{machine?.desc}</h2>
            </div>

        </>
    );

};

export default Menu;